<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn fab v-on="on" small @click="toggleBuildings()">
        <v-icon :color="color">home</v-icon>
      </v-btn>
    </template>
    <span>3D Bygninger</span>
  </v-tooltip>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
export default {
  name: "MapBuildingsToggler",
  data: function() {
    return {};
  },
  mixins: [MappingMixin],
  computed: {
    ...mapState(["is3d"]),
    color() {
      return this.buildingsLayerAdded ? "blue" : "";
    },
    buildingsLayerAdded: {
      set(buildingsLayerAdded) {
        this.setBuildingsLayerAdded(buildingsLayerAdded);
      },
      get() {
        return this.$store.state.buildingsLayerAdded;
      }
    }
  },
  watch: {
    is3d(val) {
      if (!val && this.buildingsLayerAdded) {
        this.toggleBuildings();
      }
    }
  },
  methods: {
    ...mapActions(["setSnack", "setBuildingsLayerAdded"]),
    toggleBuildings: function() {
      this.buildingsLayerAdded = !this.buildingsLayerAdded;

      if (this.buildingsLayerAdded) {
        this.setSnack("Aktiverer 3D bygninger.. Dette kan ta litt tid.");
        this.addMapProfile({
          id: "bygninger3d",
          showInfoMenu: false,
          type: "sceneLayer"
        });
      } else {
        this.removeMapProfile("bygninger3d");
      }
    }
  }
};
</script>

<style></style>
